import { mdiTownHall } from '@mdi/js'

export default {
  title: 'School',
  to: 'school-superadmin-list',
  icon: mdiTownHall,
  action: 'read',
  resource: 'SchoolAdmin',
}
